<template>
  <div class="deviceInfo">
    <div class="titleContainer">
      <img src="@/assets/favicon.png" alt="log" title="logo"/>
      <h3>网策科技</h3>
    </div>
    <p><span class="title">{{titlePrefix}}名称：</span><span class="info">{{deviceName}}</span></p>
    <p><span class="title">{{titlePrefix}}型号：</span><span class="info">{{deviceModel}}</span></p>
    <p><span class="title">{{titlePrefix}}编号：</span><span class="info">{{deviceNo}}</span></p>
    <p><span class="title">生产日期：</span><span class="info">{{productionDate | toDateFormatFilter}}</span></p>
    <p v-if="deviceSerialNo"><span class="title">{{titlePrefix}}串号：</span><span class="info">{{deviceSerialNo}}</span></p>
  </div>
</template>

<script>
import {devicesList} from "@/api/device";

export default {
  name: "DeviceInfo",
  data() {
    return {
      deviceName: '',
      deviceModel: '',
      deviceNo: '',
      productionDate: '',
      deviceSerialNo: '',
      titlePrefix: '',
      queryDeviceNo: undefined,
    };
  },
  mounted() {
    document.title = this.$t('device.deviceInfo');
    this.queryDeviceNo = this.$route.query.deviceNo;
    this.devicesList();
  },
  methods: {
    async devicesList() {
      const {
        queryDeviceNo,
      } = this;
      try {
        const decodeDeviceNo = decodeURIComponent(queryDeviceNo);
        const res = await devicesList({
          deviceNo: decodeDeviceNo,
          flag: [1, 2, 3, 100],
        });
        const {data} = res;
        const deliverys = data.records || [];
        if (deliverys.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('device.deviceDeliveryInfoMissing'),
          });
          return;
        }
        const findIndex = deliverys.findIndex(item => {
          return item.deviceNo === decodeDeviceNo;
        });
        if (findIndex === -1) {
          this.$message({
            type: 'error',
            message: this.$t('device.deviceDeliveryInfoMissing'),
          });
          return;
        }
        const {
          deviceName,
          deviceModel,
          deviceNo,
          productionDate,
          flag,
          deviceSerialNo,
        } = deliverys[findIndex];
        this.deviceName = deviceName;
        this.deviceModel = deviceModel;
        this.deviceNo = deviceNo;
        this.productionDate = productionDate;
        this.deviceSerialNo = deviceSerialNo;
        this.titlePrefix = flag === 100 ? '组件' : '设备';
      } catch (e) {
        // do nothing.
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .deviceInfo {
    padding: 10px 20px;
    .titleContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 10px;
      h3 {
        display: inline-block;
        color: black;
        margin-left: 10px;
      }
    }
    .title {
      font-size: 14px;
      color: #333333;
      vertical-align: middle;
      padding: 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: 30px;
      font-weight: bold;
    }

    .info {
      font-size: 14px;
      color: #606266;
      vertical-align: middle;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: 30px;
      display: inline-block;
    }
  }
</style>
